module.exports = __webpack_public_path__ + "static/media/ProcessingTheApplication.82abbc9f.svg";